import styled from 'styled-components';
import SelectWrapper from 'gatsby-theme-wordpress/src/components/language-switch/select-wrapper';

export default styled(SelectWrapper)`
  margin: ${(props) => props.theme.grid.containerGap};
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    margin: 0;
  }
`;
